import { initFramework } from '../main-base';

export default class AppAgnosticFrameworkInitializer {
	static get init() {
		return initFramework;
	}
}
